/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualSubjectId: core.serialization.ObjectSchema<serializers.EqualSubjectId.Raw, Truvity.EqualSubjectId> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace EqualSubjectId {
    export interface Raw {
        value: string;
    }
}
